import { GridColDef } from "@mui/x-data-grid-pro";
import { GKButton, GKDataGrid, Grid2, PlusIcon, Show } from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetPartnerQuery } from "store/features/AdminDetailsAPI";
import { extraColumnsField } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import PartnerModal from "./PartnerModal";

const columns: GridColDef[] = [
  {
    ...extraColumnsField("Name", "name", 150, 1),
  },
  {
    ...extraColumnsField("Code", "code", 150, 1),
  },
  {
    ...extraColumnsField("Email", "email", 150, 1),
    valueGetter: (params) => params?.row?.email || "-",
  },
  {
    ...extraColumnsField("Phone", "phone", 150, 1),
    valueGetter: (params) => params?.row?.phone || "-",
  },
  {
    ...extraColumnsField("Branch", "headBranch", 150, 1),
  },
];

const Partner = () => {
  useDocumentTitle("Partner");

  const navigate = useNavigate();

  const [openPartnerModal, setOpenPartnerModal] = useState(false);

  const requestBody = useGenerateQueryParams("partner");

  const { data, isFetching } = useGetPartnerQuery(requestBody);

  return (
    <Grid2 container>
      <Grid2 size={12}>
        <GKDataGrid
          rows={data?.data || []}
          columns={columns}
          loading={isFetching}
          maxHeight={"calc(100vh - 312px)"}
          onRowClick={(row) => navigate(`/app/partner/${row.id}`)}
          totalCount={data?.totalCount || 0}
          name="partner"
          headerComponent={
            <GKButton
              variant="contained"
              onClick={() => setOpenPartnerModal(true)}
              startIcon={<PlusIcon width={14} />}
            >
              Add Partner
            </GKButton>
          }
          tableName="partner_list"
        />
      </Grid2>

      <Show.When isTrue={openPartnerModal}>
        <PartnerModal open={openPartnerModal} setOpen={setOpenPartnerModal} />
      </Show.When>
    </Grid2>
  );
};

export default Partner;
